module.exports = __webpack_public_path__ + "82f1642dfda503f5b1c08329576d1311.pdf";